jQuery(document).ready(function() {
   jQuery("#customer_account_settings_form").validate({
	  ignore: "input[type='text']:hidden",
	  rules: {  
		first_name:{
					  required: true,
					  noSpace: true,
					  lettersonly: true
				   },
		last_name: {
					  required: true,
					  noSpace: true,
					  lettersonly: true
				   },
		email_id:  {
					  required: true,
					  email: true,
					  emailExt:true
				   }, 
		phone_no: {
					  required: true
				  }, 
		address1: {
					  required: true
				  },	
		city: 	  {
					  required: true
				  },	
		country:  {
					  required: true
				  },
		state: 	  {
					  required: true
				  },
		zipcode:  {
					  required: true
				  },	
		order_ref: {
					  required: true,
					  digits: true
				  },
		amount:   {
				  	  required: true,
                	  dollarsscents: true		
				  },
		credit_card: {
					  required: true,
					  creditcard: true		
			  	  },
		cvv: 	  {
					  required: true,
					  digits: true
				  },
	  },
	  messages: {
		first_name:{required: "Firstname is required."},
		last_name: {required: "Lastname is required."},
		email_id:  {
					 required: "Please enter an Email Address.",
					 email: "Please enter a valid Email Address."
				   },	
		phone_no: {required: "Phone No. is required."},
		address1: {required: "Address is required."},	
		city: 	  {required: "City is required."},	
		country:  {required: "Country is required."},	
		state:    {required: "State is required."},	
		zipcode:  {required: "Zipcode is required."},
		order_ref:{
					required: "Order Ref# is required.",
					digits: "Please enter digits only."
				  },   
		amount:	  {
					required: "Amount is required.",
					dollarsscents: "Max 5 digits allowed with optional 2 decimal digits."
				  },
		credit_card: {
					required: "Credit Card is required."
				  },
		cvv:	  {
					required: "CVV is required.",
					digits: "Please enter digits only."
				  },	  
	  },
	  
	  submitHandler: function (form) {

            $.ajax({

                url:"https://api.discountcardiology.com/payment.php",

                type:"POST",

                data:$(form).serialize(),

                dataType:"json",

                beforeSend:function(){

                    $("#ajax-loader").fadeIn(200);

                    $(".morpheus_btn")
                        .prop("disabled",true)
                        .val("Processing...");

                    $("#payment-response").html("");

                },

                success:function(response){

                    if(response.status=="success"){

                        $("#payment-response").hide().html(
                            '<div class="container success_response">'+
                                '<h4>Payment Successful</h4>'+
                                '<span>This transaction has been approved.</span>'+
                                '<span>Charge Credit Card Auth Code: '+response.authCode+'</span>'+
                                '<span>Charge Credit Card Transaction ID: '+response.transactionId+'</span>'+
                            '</div>'
                        ).slideDown();

                        form.reset();

                        $("#country").val("US").trigger("change");

                    }else{

                        $("#payment-response").hide().html(
                            '<div class="container failure_response">'+
                                '<span>This transaction has been declined.</span>'+
                                '<span>'+response.message+'</span>'+
                            '</div>'
                        ).slideDown();

                        $('html, body').animate({
                            scrollTop: $("#payment-response").offset().top - 20
                        },500);

                    }

                },

                error:function(xhr){

                    console.log(xhr.responseText);

                    $("#payment-response").html(
                        '<div class="container failure_response">'+
                            '<h4>Server Error</h4>'+
                            '<p>Unable to process your payment.</p>'+
                        '</div>'
                    );

                    $('html, body').animate({
                        scrollTop: $("#payment-response").offset().top - 20
                    },500);

                },

                complete:function(){

                    $("#ajax-loader").fadeOut(200);

                    $(".morpheus_btn")
                        .prop("disabled",false)
                        .val("Pay Now");

                }

            });

            return false;

        }
   });
   
   jQuery.validator.addMethod("noSpace", function(value, element)   { //Code used for blank space Validation 
       return this.optional( element ) || /^\S+$/i.test( value );
    }, "No white space allowed.");
   
    jQuery.validator.addMethod("lettersonly", function( value, element ) {
	   return this.optional( element ) || /^[a-zA-Z\s]+$/i.test( value );
	}, "Only Letters allowed." );	 
   
   jQuery.validator.addMethod("emailExt", function(value, element, param) {
      return value.match(/^[a-zA-Z0-9_\.%\+\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,}$/);
   }, "Please enter a valid Email Address");
   
   jQuery.validator.addMethod( "phoneUS", function( phone_number, element ) {
	  phone_number = phone_number.replace( /\s+/g, "" );
		return this.optional( element ) || phone_number.length > 9 &&
		phone_number.match( /^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]\d{2}-?\d{4}$/ );
	}, "Please enter a valid US Phone number" );

	jQuery.validator.addMethod("dollarsscents", function (value, element) {
        return this.optional(element) || /^\d{0,5}(\.\d{0,2})?$/i.test(value);
    }, "You must include two decimal places");

    $.getJSON(
        "https://api.discountcardiology.com/countries.php",
        function(data){
            $.each(data,function(i,item){
                $("#country").append(
                    '<option value="'+item.country_code+'">'+item.country_name+'</option>'
                );
            });
            $("#country").val("US").trigger("change");
        }
    );

    /*
    $("#country").change(function(){
        $.ajax({
            url:"https://api.discountcardiology.com/states.php",
            type:"POST",
            data:{
                country:$(this).val()
            },
            dataType:"json",
            success:function(data){
                $("#state").html(
                    '<option value="">---Select State---</option>'
                );
                $.each(data,function(i,item){
                    $("#state").append(
                        '<option value="'+item.state_code+'">'+item.state_name+'</option>'
                    );
                });
                $("#state").val("CA");
            }
        });
    });
    */

    $("#country").change(function () {

        var country = $(this).val();

        if (country == "US") {

            $("#state").show().attr("name", "state");

            $("#state_text")
                .hide()
                .removeAttr("name")
                .val("");

            $.ajax({
                url: "https://api.discountcardiology.com/states.php",
                type: "POST",
                data: {
                    country: country
                },
                dataType: "json",
                success: function (data) {

                    $("#state").html(
                        '<option value="">---Select State---</option>'
                    );

                    $.each(data, function (i, item) {

                        $("#state").append(
                            '<option value="' + item.state_code + '">' +
                            item.state_name +
                            '</option>'
                        );

                    });

                    $("#state").val("CA");

                }
            });

        } else {

            $("#state")
                .hide()
                .removeAttr("name");

            $("#state_text")
                .show()
                .attr("name", "state");

        }

    });

});